/* eslint camelcase: 0 */

// El pulsador es pull-up: lee invertido y normaliza a 1/0.
export const ENTRADAS_button = (block, generator) => {
  const pin = block.getFieldValue('NPIN');

  return [`(!pins.digitalReadPin(DigitalPin.${pin}) ? 1 : 0)`, generator.ORDER_ATOMIC];
};

export const ENTRADAS_obstaculo = (block, generator) => {
  const pin = block.getFieldValue('NPIN');

  return [`pins.digitalReadPin(DigitalPin.${pin})`, generator.ORDER_ATOMIC];
};

export const ENTRADAS_button_touch = (block, generator) => {
  const pin = block.getFieldValue('NPIN');

  return [`pins.digitalReadPin(DigitalPin.${pin})`, generator.ORDER_ATOMIC];
};

export const ENTRADAS_photoresistor = (block, generator) => {
  const pin = block.getFieldValue('NPIN');

  return [`pins.analogReadPin(AnalogPin.${pin})`, generator.ORDER_ATOMIC];
};

export const ENTRADAS_potentiometer = (block, generator) => {
  const pin = block.getFieldValue('NPIN');

  return [`pins.analogReadPin(AnalogPin.${pin})`, generator.ORDER_ATOMIC];
};
